// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import {
  getAppBanner,
  getIsPlpPdpAnchoringEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import AppBanner from '../views';

export const mapStateToProps = (state, ownProps) => {
  const { isBrowseAnchoredPage } = ownProps;
  return {
    isShowAppBannerKillSwitch: getAppBanner(state),
    isBrowsePageAndAnchored: getIsPlpPdpAnchoringEnabled(state) && isBrowseAnchoredPage,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    setClickAnalyticsData: (payload) => dispatch(setClickAnalyticsData(payload)),
    trackClick: () => dispatch(trackClick()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppBanner);
